// extracted by mini-css-extract-plugin
export default {"Box":"automation-graph-module__Box__lKx5mqW"};